import React, { ReactElement } from "react"
import "./App.scss"
import accounts from "./accounts.json"
import Footer from "./Footer"
import Header from "./Header"

interface Account {
  name: string
  keywords: string[]
  headerImage?: string
  id: string
}

interface AccountElementProps {
  account: Account
}
class AccountElement extends React.Component<AccountElementProps, {}> {
  constructor(props: AccountElementProps) {
    super(props)
    this.account = props.account
  }

  account: Account

  render(): ReactElement {
    return (
      <div className="account" key={this.account.id}>
        <a
          className="account--link"
          href={`https://twitter.com/intent/follow?user_id=${this.account.id}`}
          target="_blank"
          rel="noopener noreferrer"
        >
          {this.account.headerImage ? (
            <div className="account--img-wrapper">
              <img
                className="account--img"
                src={require(`./logos/${this.account.headerImage}`)}
                alt=""
              />
            </div>
          ) : null}
          <div className="spacer"></div>
          <div className="account--content">{this.account.name}</div>
        </a>
      </div>
    )
  }
}

class Description extends React.Component {
  render(): ReactElement {
    return (
      <div className="description">
        <p className="bold">好みの技術のFeedPack をフォローしよう！</p>
        <p>
          Feedal on Twitterは、9つの技術分野の最新情報をTwitterにて提供します。
        </p>
        <p>
          ツイートされる情報は公式ページなど複数のページの情報から構成されています。
        </p>
      </div>
    )
  }
}

class App extends React.Component {
  render(): ReactElement {
    const accountElements = accounts.map((account) => (
      <AccountElement account={account} key={account.name}></AccountElement>
    ))
    return (
      <div className="App">
        <Header></Header>
        <Description></Description>
        <div className="accounts">{accountElements}</div>
        <div className="spacer"></div>
        <Footer></Footer>
      </div>
    )
  }
}

export default App
